// import React, { useState } from "react";
// import { Helmet } from "react-helmet"; // Helmet import

import RandingStyle10 from "../../randing/RandingStyle10";

function Randing191({ urlCode, urlCodeSettingId }) {
  return (
    <RandingStyle10
      urlCode={urlCode}
      urlCodeSettingId={urlCodeSettingId}
      img1Path={`${process.env.REACT_APP_CDN_BASE}/images/191/01.jpg`}
      img2Path={`${process.env.REACT_APP_CDN_BASE}/images/191/02.gif`}
      qOptionImgPath={`${process.env.REACT_APP_CDN_BASE}/images/191/radio`}
      postBTN={`${process.env.REACT_APP_CDN_BASE}/images/postBtns/blue/consultInquiryButton3.png`}
      qTitleColor="#0166ff"
      qTitleImg1Path={`${process.env.REACT_APP_CDN_BASE}/images/191/Q1.jpg`}
      qTitleImg2Path={`${process.env.REACT_APP_CDN_BASE}/images/191/Q2.jpg`}
      qOptions={["앞니교정", "전체교정", "재교정", "잘모르겠음"]}
      qOptionColor="blue"
      formFieldColor="white"
      companyName="검단뉴욕치과의원"
      privacyMessage="개인정보수집에 동의하시는 분만 '상담 문의'버튼을 눌러주세요."
      footerPath={`${process.env.REACT_APP_CDN_BASE}/images/footer/geomdan.png`}
      eventDates={true}
      carrotTag={true}
    />
  );
}

export default Randing191;
